import React from 'react'
import CenterModal from '../../../components/Modals/center-modal';
import { ReactComponent as CloseIcon } from '../../../assets/close.svg';
import { ReactComponent as RequestSentIcon } from '../../../assets/plus_icon/request.svg'


const RequestSentModal = ({ show, closeModal, name }) => {
    return (

        <div className='bg-white rounded-xl md:max-w-[423px] md:basis-[423px] px-6 grow-0 shrink-0 md:!mt-0 !mt-10 md:!mb-0 !mb-10 shadow-shadowcard '>
            {/* <div className='!max-w-[423px]'> */}
            <div className='relative !p-12 flex flex-col items-center justify-center'>
                <div>
                    <span>
                        <RequestSentIcon />
                    </span>
                    <button onClick={closeModal} className='absolute right-5 top-5'><CloseIcon /></button>
                </div>
                <h4 className='text-xl font-semibold mb-2.5 !mt-6'>Request Sent </h4>
                <div className='text-black700 text-base font-medium !mb-3 text-center'>Mr. <span className='font-semibold'>{name}</span> has been notified of your joining request. Reach out to your company owner.</div>

            </div>
            {/* </div> */}
        </div>
    )
}

export default RequestSentModal;